import { render } from "./page-header-v2.vue?vue&type=template&id=57412d1a&scoped=true"
import script from "./page-header-v2.vue?vue&type=script&lang=js"
export * from "./page-header-v2.vue?vue&type=script&lang=js"

import "./page-header-v2.vue?vue&type=style&index=0&id=57412d1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57412d1a"]])

export default __exports__